import { useEffect, useState } from "react";
import { loadZens } from "../data/loadZens";
import SplitListPreview from "./SplitListPreview";

export default function ZenDevHeroList() {
  const [zens, setZens] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    loadZens()
      .then((data) => {
        if (!mounted) return;
        setZens(data || []);
      })
      .catch((err) => {
        console.error("Zen Dev Fetch Error:", err);
        if (!mounted) return;
        setError("Zen Dev konnte nicht geladen werden.");
      })
      .finally(() => {
        if (!mounted) return;
        setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div className="p-3 sm:p-6 max-w-6xl pt-6 sm:pt-14 pb-8 sm:pb-10 mx-auto">
      <SplitListPreview
        label="Zen Dev"
        command="ls apps/"
        loading={loading}
        error={error}
        introKicker="Zen Dev"
        introHeadline="Build in public: Tools, Workflows und echte Entwicklungswege."
        hideCommand
        showDesktopPreview={false}
        items={zens.map((zen) => ({
          id: `zen-${zen.slug}`,
          title: zen.title,
          subtitle: zen.subtitle,
          meta: "Zen Dev",
          date: zen.date,
          image: zen.image,
          href: `/zen/${zen.slug}`,
          external: false,
        }))}
      />
    </div>
  );
}
